import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu-icons/bell.png'
import _imports_1 from '@/assets/menu-icons/message.png'


const _withScopeId = n => (_pushScopeId("data-v-e5b2be3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-section" }
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = { class: "user-designation" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"icon-container\" data-v-e5b2be3e><div class=\"bell-container\" data-v-e5b2be3e><img src=\"" + _imports_0 + "\" data-v-e5b2be3e><span data-v-e5b2be3e>0</span></div><div class=\"message-container\" data-v-e5b2be3e><img src=\"" + _imports_1 + "\" data-v-e5b2be3e><span data-v-e5b2be3e>0</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('generic.welcome')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_3, _toDisplayString($setup.currentUser.Name || $setup.t('generic.userName')), 1)
    ]),
    _hoisted_4
  ]))
}